import { Card } from '@maas-components/core'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
  border: 1px solid #ececec;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #f7f7f7;
  max-width: 285px;
`
export const StyledCardGroup = styled('div')`
  display: flex;
  gap: 24px;
`
